<template>
  <div style="margin-top: 5rem;">

    <div>
      <p class="error" v-if="errorStatus.message">{{ errorStatus.message }}</p>
    </div>

    <b-form @submit.prevent="login" @reset="onReset" v-if="show">
      <b-form-group id="inputGroup1"
                    label="User:"
                    horizontal
                    label-for="username">
        <b-form-input id="username" class="w-50"
                      type="email"
                      v-model="form.username"
                      required
                      placeholder="Enter user">
        </b-form-input>
      </b-form-group>
      <b-form-group id="inputGroup2"
                    label="Passwort:"
                    horizontal
                    label-for="password">
        <b-form-input id="password" class="w-50"
                      type="password"
                      v-model="form.password"
                      required
                      placeholder="Enter Password">
        </b-form-input>
      </b-form-group>
      <input type="hidden" v-model="form.grant_type" name="grant_type">
      <b-button type="submit" variant="primary">Login</b-button>
      <b-button type="reset" variant="danger">Reset</b-button>
    </b-form>
  </div>
</template>

<style>
.error {
    color: red;
}
</style>

<script>
  import {AUTH_REQUEST} from '@/store/actions/auth'

  export default {
    name: 'login',
    data () {
     return {
          errorStatus: {message: ''},
          form: {
            username: '',
            password: '',
            grant_type: 'password'
          },
          show: true
      }
    },
    methods: {
        login: function () {
            const { username, password, grant_type } = this.form
            this.$store.dispatch(AUTH_REQUEST, { username, password, grant_type })
            .then(() => {
              this.$router.push('/')
            })
            .catch(error => {
                this.errorStatus.message = "User oder Passwort ist nicht korrekt. Bitte probieren Sie es noch einmal."
                console.log("MyError" + error.message)
                this.show = false;
                this.$nextTick(() => { this.show = true });
            })
        },
         onReset (evt) {
              evt.preventDefault();
              /* Reset our form values */
              this.form.username = '';
              this.form.password = '';
              this.errorStatus.message = '';
              /* Trick to reset/clear native browser form validation state */
              this.show = false;
              this.$nextTick(() => { this.show = true });
            }
    },
  }
</script>